import { createSelector } from 'reselect';

export const getUserCommentsMap = (state) => state.userComments.map;

const getIdList = (state, idList) => idList;

export const getUserCommentsByIdList = createSelector([getUserCommentsMap, getIdList], (commentsMap, idList) =>
  idList.map((id) => commentsMap[id]),
);

export const getUserCommentsCount = (state) => state.userComments.metadata.count;

export const getUserCommentsCursor = (state) => state.userComments.metadata.cursor;

export const getUserCommentsIdList = (state) => state.userComments.idList;

export const getUserComments = (state) => getUserCommentsByIdList(state, getUserCommentsIdList(state));
